module.exports = __webpack_public_path__ + "img/game.0c27afd4.svg";